export default __webpack_public_path__ + "static/media/promo-3.4bed0899.png";